import React from 'react';
import { CalendarCheck, DollarSign, Percent, CheckCircle2, TrendingUp, TrendingDown, AlertTriangle } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


// Grid plan: 5 cards → grid-cols-4 → row 1: hero spans 2 cols + 2 regular, row 2: 2 cards span 2 cols each (2+2)
// Actually: 5 cards → 2+2+1 = row1: 2 regular + 1 hero(span2), row2: 2 regular
// Final: grid-cols-4, card1 normal, card2 normal, card3 spans 2 (hero), row2: card4 spans 2, card5 spans 2

const kpis = [
  {
    id: 'kpi-today',
    label: "Today\'s Bookings",
    value: '9',
    sub: '3 confirmed · 2 in progress · 4 pending',
    trend: '+2 vs yesterday',
    trendUp: true,
    icon: CalendarCheck,
    iconBg: 'bg-blue-50',
    iconColor: 'text-primary',
    span: 1,
    alert: false,
  },
  {
    id: 'kpi-pending',
    label: 'Pending Confirmations',
    value: '4',
    sub: 'Require action — oldest is 2h ago',
    trend: '↑ 2 since this morning',
    trendUp: false,
    icon: AlertTriangle,
    iconBg: 'bg-amber-50',
    iconColor: 'text-amber-500',
    span: 1,
    alert: true,
  },
  {
    id: 'kpi-revenue',
    label: 'Revenue This Week',
    value: '$3,847',
    sub: 'Confirmed + completed bookings',
    trend: '+18.4% vs last week',
    trendUp: true,
    icon: DollarSign,
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
    span: 2,
    alert: false,
    hero: true,
  },
  {
    id: 'kpi-utilization',
    label: 'Slot Utilization',
    value: '73%',
    sub: '22 of 30 slots filled this week',
    trend: '-5% vs last week',
    trendUp: false,
    icon: Percent,
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
    span: 2,
    alert: false,
  },
  {
    id: 'kpi-completed',
    label: 'Completed This Month',
    value: '61',
    sub: 'Avg. $94 per booking',
    trend: '+12 vs last month',
    trendUp: true,
    icon: CheckCircle2,
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
    span: 2,
    alert: false,
  },
];

export default function KPIBentoGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {kpis?.map((kpi) => {
        const Icon = kpi?.icon;
        const TrendIcon = kpi?.trendUp ? TrendingUp : TrendingDown;
        return (
          <div
            key={kpi?.id}
            className={`bg-card rounded-xl border shadow-card p-5 flex flex-col gap-3 ${
              kpi?.alert ? 'border-amber-200 bg-amber-50/50' : 'border-border'
            } ${kpi?.span === 2 ? 'lg:col-span-2' : ''} ${kpi?.hero ? 'relative overflow-hidden' : ''}`}
          >
            {kpi?.hero && (
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent pointer-events-none" />
            )}
            <div className="flex items-start justify-between relative z-10">
              <div className={`w-9 h-9 rounded-lg ${kpi?.iconBg} flex items-center justify-center flex-shrink-0`}>
                <Icon size={18} className={kpi?.iconColor} />
              </div>
              {kpi?.alert && (
                <span className="text-[10px] font-700 text-amber-600 bg-amber-100 px-2 py-0.5 rounded-full uppercase tracking-wider">
                  Action needed
                </span>
              )}
            </div>
            <div className="relative z-10">
              <p className="text-[11px] font-600 text-muted-foreground uppercase tracking-wider mb-1">{kpi?.label}</p>
              <p className={`font-800 tabular-nums text-foreground ${kpi?.hero ? 'text-3xl' : 'text-2xl'}`}>{kpi?.value}</p>
              <p className="text-xs text-muted-foreground mt-1">{kpi?.sub}</p>
            </div>
            <div className={`flex items-center gap-1.5 text-xs font-600 relative z-10 ${kpi?.trendUp ? 'text-emerald-600' : 'text-red-500'}`}>
              <TrendIcon size={12} />
              {kpi?.trend}
            </div>
          </div>
        );
      })}
    </div>
  );
}